import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { INDUSTRIES, IMAGES } from "@/data/site";

export default function Industries() {
  const [active, setActive] = useState(0);

  return (
    <section id="industries" data-testid="industries-section" className="relative py-28 lg:py-40 border-t border-border">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="font-mono text-xs tracking-[0.35em] text-primary uppercase">04 — Sectors</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display font-medium text-4xl lg:text-6xl tracking-tight leading-[1.02]">
                Industries<br />We Serve
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 hidden lg:block aspect-[4/3] overflow-hidden border border-border">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={active}
                    src={active % 2 === 0 ? IMAGES.stamping : IMAGES.machining}
                    initial={{ opacity: 0, scale: 1.05 }}
                    animate={{ opacity: 0.85, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    alt="Industry"
                    className="w-full h-full object-cover"
                  />
                </AnimatePresence>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-border">
              {INDUSTRIES.map((ind, i) => (
                <Reveal key={ind} delay={i * 0.04}>
                  <button
                    onMouseEnter={() => setActive(i)}
                    onFocus={() => setActive(i)}
                    data-testid={`industry-item-${i}`}
                    className="group w-full flex items-center justify-between py-6 border-b border-border text-left"
                  >
                    <div className="flex items-baseline gap-6">
                      <span className="font-mono text-sm text-primary">{String(i + 1).padStart(2, "0")}</span>
                      <span className="font-display text-2xl lg:text-4xl font-medium text-foreground/70 group-hover:text-foreground group-hover:translate-x-2 transition-all duration-300">
                        {ind}
                      </span>
                    </div>
                    <span className="font-mono text-xs text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity">
                      →
                    </span>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
